import React from 'react';
import { PowerOff, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { formatRupiah, formatAge } from './StoppedCustomersList';

export default function StopCustomerDialog({ customer, loading, onCancel, onConfirm }) {
  return (
    <Dialog open={!!customer} onOpenChange={(o) => { if (!o && !loading) onCancel(); }}>
      <DialogContent className="sm:max-w-md" data-testid="stop-customer-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-rose-700 dark:text-rose-400">
            <PowerOff className="w-5 h-5" /> Putuskan Pelanggan?
          </DialogTitle>
          <DialogDescription>
            <span className="font-semibold text-slate-800 dark:text-slate-100" data-testid="stop-dialog-customer-name">{customer?.name}</span>
            {' '}· {customer?.account_number} · terisolir {formatAge(customer?.overdue_days)}
          </DialogDescription>
        </DialogHeader>
        <ul className="space-y-2 text-sm text-slate-600 dark:text-slate-300 list-disc pl-5">
          <li>Status menjadi <b>Berhenti</b>: login PPPoE diblokir dan sesi aktif diputus.</li>
          <li>Tidak dibuatkan tagihan bulanan baru.</li>
          <li>
            Tunggakan <b data-testid="stop-dialog-outstanding">{formatRupiah(customer?.unpaid_total)}</b> ({customer?.unpaid_count} tagihan) tetap tercatat sebagai piutang.
          </li>
          <li>Data dan riwayat pelanggan tetap tersimpan. Jika seluruh tunggakan dilunasi, pelanggan aktif kembali otomatis.</li>
        </ul>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onCancel} disabled={loading} data-testid="stop-dialog-cancel-btn">Batal</Button>
          <Button onClick={onConfirm} disabled={loading} className="bg-rose-600 hover:bg-rose-700 text-white" data-testid="stop-dialog-confirm-btn">
            {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <PowerOff className="w-4 h-4 mr-2" />}
            Ya, Putuskan
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
